import dayjs from "../../../utils/dayjs";
import getDateString from "./getDateString";
import splitArrayInChunks from "./splitArrayInChunks";
const createDateCells = (date, min, max) => {
  const target = date.startOf("month").hour(0).minute(0).second(0).millisecond(0);
  const weekdays = dayjs.weekdays(true);
  const cells = [];
  const push = (d) => cells.push({
    date: d,
    key: getDateString(d),
    isCurrentMonth: d.isSame(target, "month"),
    isInDateRange: d.clamp(min, max, "date") === d
  });
  Array(weekdays.indexOf(target.format("dddd"))).fill(0).forEach((_, dayOffset, { length }) => {
    push(target.subtract(length - dayOffset, "day"));
  });
  Array(target.daysInMonth()).fill(0).forEach((_, day) => {
    push(target.add(day, "day"));
  });
  Array(Math.abs(target.endOf("month").weekday() - weekdays.length + 1)).fill(0).forEach((_, dayOffset) => {
    push(target.endOf("month").hour(0).minute(0).second(0).millisecond(0).add(dayOffset + 1, "day"));
  });
  return splitArrayInChunks(cells, weekdays.length);
};
var createDateCells_default = createDateCells;
export {
  createDateCells_default as default
};
